module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-SemiBold.72c09c3e.eot";